import { action } from "typesafe-actions";
import ActionTypes from "../../constants";

export const initialLoadingFinished = (edata = {}, odata = {}) =>
  action(ActionTypes.TRACK, {
    ekind: "interaction_enabled",
    okind: "tracker",
    edata: {
      screen: "registration_number_screen",
      ...edata
    },
    ...odata
  });

export const findYourCarClicked = (edata = {}, odata = {}) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "find_your_car_clicked",
    okind: "tracker",
    edata: {
      screen: "registration_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const userDetailsScreenLoaded = (edata = {}, odata = {}) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "user_details_screen_loaded",
    okind: "tracker",
    edata: {
      screen: "user_details",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const userDetailsEditMmvClicked = (edata = {}, odata = {}) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "user_details_mmv_edit_clicked",
    okind: "tracker",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const pincodeFocus = (edata = {}, odata = {}) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "pincode_clicked",
    okind: "tracker",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const leadGenerated = (edata = {}, odata = {}) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "lead_generated",
    okind: "tracker",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const mobileNumberEntered = (edata = {}, odata = {}) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "mobile_number_entered",
    okind: "tracker",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const mmvFlowInitiated = (edata = {}, odata = {}) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "mmv_flow_initiated",
    okind: "tracker",
    edata: {
      screen: "registration_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const rcResponseScreenLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "rc_response_screen_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "fastlane_response_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const rcResponseAccepted = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "rc_response_accepted",
    okind: "auto_proposal",
    edata: {
      screen: "fastlane_response_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const selectMakeModelVariantScreenLoaded = (edata = {}, odata = {}) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "select_mmv_screen_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const variantConfirmed = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "continue_cta_clicked_mobile",
    okind: "auto_proposal",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const mmvScreenContinueClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "mmv_screen_continue_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const mmvConfirmationScreenLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "mobile_number_screen_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

// Make Model
export const findMakeModelClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "find_make_model_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const findMakeModelModalOpened = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "find_make_model_modal_opened",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const popularCarsSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "popular_cars_selected",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const searchMakeModelClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "search_make_model_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const makeModelSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "make_model_selected",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const makeModelModalClosed = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "make_model_modal_closed",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

// fuelType
export const selectFuelTypeModalLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "select_fuel_type_modal_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const selectFuelType = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "select_fuel_type",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const fuelTypeClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "fuel_type_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const fuelTypeSkipped = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "fuel_type_skipped",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const fuelTypeModalClosed = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "fuel_type_modal_closed",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

// variant type
export const selectVariant = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "select_variant",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const selectVariantLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "select_variant_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const variantSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "variant_selected",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const variantSkipped = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "select_variant",
    okind: "variant_skipped",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const variantModalClosed = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "variant_modal_closed",
    okind: "auto_proposal",
    edata: {
      screen: "select_make_model_variant_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

// add
export const commercialOrPrivateScreenLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "comm_private_screen_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "commercial_vehicle_capture_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const privateCarSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "private_car_selected",
    okind: "auto_proposal",
    edata: {
      screen: "commercial_vehicle_capture_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const commericalCarSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "commercial_car_selected",
    okind: "auto_proposal",
    edata: {
      screen: "commercial_vehicle_capture_screen",
      ...edata
    },
    ...odata
  });

export const previousPolicyTypeScreenLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "previous_policy_type_screen",
    okind: "auto_proposal",
    edata: {
      screen: "previous_policy_type_screen",
      ...edata
    },
    ...odata
  });

export const previousPolicyTypeTPSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "pcv_tp_selected",
    okind: "auto_proposal",
    edata: {
      screen: "previous_policy_type_screen",
      ...edata
    },
    ...odata
  });

export const previousPolicyTypeComprehensiveSelected = ({
  edata = {},
  odata = {}
}) =>
  action(ActionTypes.TRACK, {
    ekind: "pcv_comprehensive_selected",
    okind: "auto_proposal",
    edata: {
      screen: "previous_policy_type_screen",
      ...edata
    },
    ...odata
  });

export const pincodeCaptureScreenLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "pincode_capture_screen_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "pincode_capture_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const carPurchaseQuestionLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "car_purchase_question_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "car_purchase_question_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const carPurchaseDropdownClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "car_purchase_dropdown_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "car_purchase_question_screen",
      journey: "new_car",
      product_state: "Pre quote",
      ...edata
    },
    ...odata
  });

export const carPurchaseAnswerSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "car_purchase_answer_selected",
    okind: "auto_proposal",
    edata: {
      screen: "car_purchase_question_screen",
      journey: "new_car",
      product_state: "Pre quote",
      ...edata
    },
    ...odata
  });

export const externalCngYesSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "external_cng_yes_selected",
    okind: "auto_proposal",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const externalCngNoSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "external_cng_no_selected",
    okind: "auto_proposal",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const externalCngValueEntered = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "external_cng_value_entered",
    okind: "auto_proposal",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const externalCngValueError = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "external_cng_value_error",
    okind: "auto_proposal",
    edata: {
      screen: "mobile_number_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const pincodeConfirmed = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "pincode_confirmed",
    okind: "auto_proposal",
    edata: {
      screen: "pincode_capture_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const rtoScreenLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "rto_screen_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "rto_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const rtoSearchStarted = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "rto_search_started",
    okind: "auto_proposal",
    edata: {
      screen: "rto_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const rtoPopularSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "popular_rto_selected",
    okind: "auto_proposal",
    edata: {
      screen: "rto_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const rtoSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "rto_selected",
    okind: "auto_proposal",
    edata: {
      screen: "rto_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const rtoConfirmed = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "rto_confirmed",
    okind: "auto_proposal",
    edata: {
      screen: "rto_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const brandNewCTAClicked = (edata, odata) =>
  action(ActionTypes.TRACK, {
    ekind: "brand_new_car_cta_clicked",
    okind: "tracker",
    edata: {
      screen: "",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const pincodeNotServicable = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "pincode_not_servicable",
    okind: "tracker",
    edata: {
      screen: "pincode_capture_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const newCarBuyScreenLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "lead_form_page_loaded",
    okind: "tracker",
    edata: {
      screen: "",
      ...edata
    },
    ...odata
  });

export const newCarGetQuoteClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "new_car_get_quote_clicked",
    okind: "tracker",
    edata: {
      screen: "",
      ...edata
    },
    ...odata
  });

export const newCarOtpScreenLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "new_car_otp_screen_loaded",
    okind: "tracker",
    edata: {
      screen: "",
      ...edata
    },
    ...odata
  });

export const newCarOtpSubmitted = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "new_car_otp_submitted",
    okind: "tracker",
    edata: {
      screen: "",
      ...edata
    },
    ...odata
  });

export const newCarLeadSubmitted = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "new_car_lead_submitted",
    okind: "tracker",
    edata: {
      screen: "",
      ...edata
    },
    ...odata
  });

export const newCarSurveyScreenLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "survey_screen_loaded",
    okind: "tracker",
    edata: {
      screen: "",
      ...edata
    },
    ...odata
  });

export const newCarSurveyQuestionAnswered = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "survey_question_answered",
    okind: "tracker",
    edata: {
      screen: "",
      ...edata
    },
    ...odata
  });

export const commericalCarYesSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "commercial_car_yes_selected",
    okind: "auto_proposal",
    edata: {
      screen: "vehicle-details",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const commericalCarNoSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "commercial_car_no_selected",
    okind: "auto_proposal",
    edata: {
      screen: "vehicle-details",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const vehicleTypeSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "vehicle_type_selected",
    okind: "auto_proposal",
    edata: {
      screen: "vehicle-details",
      journey: "new_car",
      ...edata
    },
    ...odata
  });

export const phoneNumberFocus = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "phonenumber_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "user_details",
      journey: "car",
      ...edata
    },
    ...odata
  });

export const vehicleDetailsScreenLoaded = (edata = {}, odata = {}) =>
  action(ActionTypes.NEW_CAR_TRACK, {
    ekind: "vehicle_details_screen_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "vehicle_details_screen",
      journey: "new_car",
      ...edata
    },
    ...odata
  });
